var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Übersicht'),"tooltipMessage":"Hier sehen Sie algemeine Statistiken","showMoreButton":false,"menus":_vm.menus},on:{"otherMenuActionEmit":_vm.moreActionSelectedEmit}}),_c('Dashboard',{attrs:{"chartMode":_vm.chartMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }